export default __webpack_public_path__ + "static/media/journey-line.daadae82.svg";